import axios from 'axios'

import {
    NotificationCenterHeaderName,
    NotificationCenterLog,
} from '../../@paco/entities/NotificationCenter/NotificationCenter'

import { DepartmentResource, DepartmentSoftDeleteRequest, DepartmentViewModel } from './Departments'
import { transformDepartmentResource } from './DepartmentsTransformers'

export const fetchDepartmentsApiCall = async (): Promise<DepartmentViewModel[]> => {
    const includes = ['group']

    const url = new URL(`${process.env.REACT_APP_API_URL}/departments`)

    url.searchParams.append('include', includes.join(','))

    const response = await axios.get<DepartmentResource[]>(String(url))

    return response.data.map(transformDepartmentResource)
}


export const patchSoftDeleteDepartmentApiCall = async (
    request: DepartmentSoftDeleteRequest,
    eventLogTrackerData: NotificationCenterLog,
): Promise<DepartmentViewModel> => {
    const includes = ['group']

    const url = new URL(`${process.env.REACT_APP_API_URL}/departments/${request.id}`)

    url.searchParams.append('include', includes.join(','))

    const response = await axios.patch<DepartmentResource>(String(url), { data: request }, {
        headers: {
            [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
        },
    })

    return transformDepartmentResource(response.data)
}
